import { Crown, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { TIER_STYLE } from "@/lib/odds";

export function TierBadge({ tier, className = "" }) {
  return (
    <span data-testid="tier-badge" className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${TIER_STYLE[tier] || TIER_STYLE.free} ${className}`}>
      {tier === "premium" && <Crown size={11} />}
      {tier}
    </span>
  );
}

export function UpgradeGate({ title, description, required = "Premium", testId = "upgrade-gate" }) {
  return (
    <div data-testid={testId} className="glass-card flex flex-col items-start gap-3 border-dashed border-amber-500/40 bg-amber-500/5 p-6">
      <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-500/15 text-amber-400"><Lock size={18} /></span>
      <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">{title}</h3>
      <p className="text-sm text-slate-400">{description}</p>
      <Link to="/pricing" data-testid={`${testId}-upgrade-link`} className="btn-primary !bg-amber-400 hover:!bg-amber-300">Unlock with {required}</Link>
    </div>
  );
}
